<template>
  <div class="publicAccess">
    <box :title="$t('nav-public-access')">
      <div class="pa-2">
        <div class="center">
          <strong>{{ lblMsgText }}</strong>
        </div>
        <v-divider class="my-2"></v-divider>
        <v-row>
          <v-col sm="6">
            <div class="d-flex">
              <label class="center ml-2" for="sectionType"
                >{{ $t("sectionType") }}:
              </label>
              <v-select
                v-if="pnlSectionsVisible"
                hide-details
                v-model="sectionType"
                :items="sectionTypes"
                :label="$t('sectionType')"
                item-text="Name"
                item-value="Code"
                return-object
                dense
                solo
                v-on:change="changeSectionType"
                class="my-auto py-0"
              ></v-select>
            </div>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            class="pa-0"
            cols="6"
            sm="4"
            v-for="(item, index) in permissionList"
            :key="index"
          >
            <v-checkbox
              multiple
              hide-details
              :value="item.permissionID"
              :label="item.permissionName"
              v-model="selectedPermissions"
              class="checkbox-rtl"
            />
          </v-col>
        </v-row>
        <v-checkbox
          v-if="chkResetAllVisible"
          hide-details
          :label="$t('publivAccess.chkResetAllText')"
          v-model="isChkResetAllChecked"
          class="checkbox-rtl"
        />

        <v-data-table
          v-if="grdPersonelVisible"
          class="mt-3"
          dense
          :disable-sort="true"
          :headers="sectionPersonelsHeaders"
          :items="sectionPersonels"
          disable-pagination=""
          hide-default-footer
        >
          <template v-slot:header.havePermission="{}">
            <v-checkbox
              dense
              hide-details="true"
              v-model="isCheckHeaderSection"
              @click.stop="checkHeaderSection()"
            ></v-checkbox>
          </template>
          <template v-slot:item.havePermission="{ item }">
            <v-checkbox
              dense
              hide-details="true"
              v-model="item.havePermission"
              @click.stop=""
            ></v-checkbox>
          </template>
        </v-data-table>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="submit">{{ $t("submit") }}</v-btn>
        </v-card-actions>
      </div>
    </box>
  </div>
</template>

<script>
import EosToastType from "../../../model/EosToastType";
import ResultType from "../../../model/ResultType";
import EosUtils from "../../../utils/EosUtils";
export default {
  data() {
    return {
      isCheckHeaderSection: false,
      args: null,
      permissionList: [],
      selectedPermissions: [],
      sectionType: "",
      sectionTypes: [],
      lblMsgText: "",
      chkResetAllVisible: false,
      pnlSectionsVisible: false,
      isChkResetAllChecked: false,
      grdPersonelVisible: false,
      sectionPersonels: [],
      sectionPersonelsHeaders: [
        {
          text: this.$t(""),
          value: "havePermission",
        },
        {
          text: this.$t("person-name"),
          value: "PersonName",
        },
        {
          text: this.$t("card-no"),
          value: "PERNO",
        },
      ],
    };
  },
  mounted() {
    //debugger
    this.GetPersonelPermissionList();
  },
  watch: {
    "$route.query"() {
      this.pageLoad();
    },
  },
  methods: {
    checkHeaderSection() {
      if (this.isCheckHeaderSection) {
        this.sectionPersonels.forEach((element) => {
          element.havePermission = true
        });
      } else {
        this.sectionPersonels.forEach((element) => {
          element.havePermission = false
        });
      }
    },
    pageLoad() {
      this.args = this.$route.query;
      if (this.args && this.args.pid) {
        this.pnlSectionsVisible = false;
        this.chkResetAllVisible = false;
        var perno = this.args.pid;

        this.$store.dispatch("EosPersonelDetail", { perno }).then((result) => {
          //console.log(result);
          if (result.type === ResultType.success) {
            var personelDetails = result.data;
            this.lblMsgText = " تغییر دسترسی " + personelDetails.PersonName;
            if (personelDetails.Permission) {
              this.LoadPersonPermission(personelDetails.Permission);
            } else {
              this.LoadDefaultPermission();
            }
          }
        });
      } else {
        this.lblMsgText =
          "لطفا امکاناتی که بین تمام اعضای سازمان مشترک می باشد را انتخاب کنید";
        this.LoadDefaultPermission();
        this.chkResetAllVisible = true;
        this.pnlSectionsVisible = true;
        this.LoadSectionList();
      }
    },
    LoadDefaultPermission() {
      this.$store.dispatch("readwebkartsetting").then((result) => {
        if (result.type === ResultType.success) {
          var settings = result.data;
          var permission = settings.DefaultPermission;
          this.LoadPersonPermission(permission);
        }
      });
    },
    LoadPersonPermission(permission) {
      this.selectedPermissions.splice(0);
      for (var i = 0; i < permission.length; i++) {
        if (permission[i] == 1) {
          this.permissionList.forEach((p) => {
            if (p.permissionID == i) {
              this.selectedPermissions.push(p.permissionID);
            }
          });
        }
      }
    },
    LoadSectionList() {
      if (EosUtils.isWebKartAdmin()) {
        this.getAllSection();
      } else {
        this.getSectionWithPermissionNumber();
      }
    },
    getAllSection() {
      this.sectionTypes.splice(0);
      this.sectionTypes.push({ Name: this.$t("allSection"), Code: "0" });

      this.$store.dispatch("sections/GetAllSections").then((result) => {
        ////console.log(result);
        if (result.type == ResultType.success) {
          this.sectionTypes.push(...result.data);
          if (this.sectionTypes.length > 0) {
            this.sectionType = this.sectionTypes[0];
          }

          //this.search();
        }
      });
    },
    async getSectionWithPermissionNumber() {
      var params = new URLSearchParams();
      params.append("accessTo", 13);

      this.$store
        .dispatch("sections/GetSectionsList", { params })
        .then((result) => {
          if (result.type == ResultType.success) {
            this.sectionTypes.push(...result.data);
            if (this.sectionTypes.length > 0) {
              this.sectionType = this.sectionTypes[0];
            }

            //this.search();
          }
        });
    },
    changeSectionType() {
      this.isCheckHeaderSection = false
      if (this.sectionType?.Code?.toString().trim() == "0") {
        this.chkResetAllVisible = true;
        this.isChkResetAllChecked = true;
        this.grdPersonelVisible = false;
        this.LoadDefaultPermission();
      } else {
        this.chkResetAllVisible = false;
        this.grdPersonelVisible = true;

        var getSectionPermissionsParams = {
          sectioncode: this.sectionType?.Code?.toString().trim(),
        };
        this.$store
          .dispatch("getSectionPermissions", { getSectionPermissionsParams })
          .then((result) => {
            //console.log(result);
            if (result.type === ResultType.success) {
              this.sectionPersonels = result.data.Table;
            }
          });

        this.selectedPermissions.splice(0);
      }
    },
    GetPersonelPermissionList() {
      //debugger
      this.$store.dispatch("GetPersonelPermissionList").then((result) => {
        if (result.type === ResultType.success) {
          this.permissionList = result.data.Table;
          this.pageLoad();
        }
      });
    },
    submit() {
      var msg = "";
      if (
        this.selectedPermissions.includes(8) &&
        this.selectedPermissions.includes(9)
      ) {
        msg =
          "مشاهده کارکرد ماهانه و دوره ای به طور همزمان قابل انتخاب نمی باشند.";
        //console.log(msg);
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: msg,
        });
        return;
      }

      if (
        this.selectedPermissions.includes(9) &&
        this.selectedPermissions.includes(20)
      ) {
        msg =
          "مشاهده کارکرد دوره ای برای وضعیت کارکرد ماهانه قابل انتخاب نمی باشند.";
        //console.log(msg);
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: msg,
        });
        return;
      }

      if (
        this.selectedPermissions.includes(8) &&
        !this.selectedPermissions.includes(20)
      ) {
        msg =
          "مشاهده کارکرد ماهانه برای وضعیت کارکرد دوره ای قابل انتخاب نمی باشند.";
        //console.log(msg);
        this.$EosToast.show({
          type: EosToastType.warning,
          msg: msg,
        });
        return;
      }

      if (this.sectionType?.Code?.toString().trim() != "0" && !this.args.pid) {
        //  AtLeast one personnel must be selected
        var selectedPersonels = this.sectionPersonels.filter(
          (personel) => personel.havePermission == 1
        );
        if (selectedPersonels.length == 0) {
          msg = "حداقل یکی از پرسنل بخش باید انتخاب شوند";
          //console.log(msg);
          this.$EosToast.show({
            type: EosToastType.warning,
            msg: msg,
          });
          return;
        }
      }

      var permissions = Array(100).fill(0);
      this.selectedPermissions.forEach((element) => {
        permissions[Number(element)] = 1;
      });

      var strPermission = permissions.join("");
      //console.log(strPermission);

      if (this.args && this.args.pid) {
        //
        var updatePermissionParams = {
          perno: this.args.pid,
          permission: strPermission,
        };
        this.$store
          .dispatch("UpdatePermission", { updatePermissionParams })
          .then((result) => {
            //console.log(result);
            if (result.type === ResultType.success) {
              this.$EosToast.show({
                type: EosToastType.success,
                msg: this.$t("operationSuccess"),
              });
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                msg: result.error || this.$t("operationFailed"),
              });
            }
          });
        //lblChangeMsg.Text = Properties.eosWinKartWebResource.functionDone;
      } else {
        if (this.sectionType?.Code?.toString().trim() == "0") {
          var updateDefaultPermissionParams = {
            permission: strPermission,
          };
          this.$store
            .dispatch("UpdateDefaultPermission", {
              updateDefaultPermissionParams,
            })
            .then((result) => {
              //console.log(result);
              if (result.type === ResultType.success) {
                this.$EosToast.show({
                  type: EosToastType.success,
                  msg: this.$t("operationSuccess"),
                });
              } else {
                this.$EosToast.show({
                  type: EosToastType.error,
                  msg: result.error || this.$t("operationFailed"),
                });
              }
            });

          if (this.isChkResetAllChecked) {
            this.$store
              .dispatch("ResetPersonsDedicatedPermission")
              .then((result) => {
                //console.log(result);
                if (result.type === ResultType.success) {
                  /*this.$EosToast.show({
                    type: EosToastType.success,
                    msg: this.$t("operationSuccess"),
                  });*/
                } else {
                  this.$EosToast.show({
                    type: EosToastType.error,
                    msg: result.error || this.$t("operationFailed"),
                  });
                }
              });
          }
        } else {
          var selectedPersonelList = this.sectionPersonels.filter(
            (personel) => personel.havePermission == 1
          );
          var pernos = "";
          if (selectedPersonelList.length > 0) {
            var list = selectedPersonelList.map((personel) => personel.PERNO);
            pernos = list.join(",");
          }
          var payload = {
            permission: strPermission,
            perno: pernos,
          };
          this.$store
            .dispatch("UpdateSectionsPersonPermission", {
              payload,
            })
            .then((result) => {
              //console.log(result);
              if (result.type === ResultType.success) {
                this.$EosToast.show({
                  type: EosToastType.success,
                  msg: this.$t("operationSuccess"),
                });
              } else {
                this.$EosToast.show({
                  type: EosToastType.error,
                  msg: result.error || this.$t("operationFailed"),
                });
              }
            });
        }
      }
    },
  },
};
</script>

<style>
</style>